<script setup>
import { ref } from "vue";
import logo from "@/assets/logo/Logo.png";

defineProps({
  setAuth: Function,
});

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};
</script>

<template>
  <header class="landing-header">
    <!-- SEBI Registration Bar -->
    <div class="sebi-registration-bar">
      <span class="sebi-text">SEBI Registered Investment Advisor - INA000020554</span>
    </div>

    <div class="header-container">
      <!-- Logo -->
      <div class="header-logo">
        <img :src="logo" alt="AssetNivesh" class="logo-img" />
      </div>

      <!-- Center Badge -->
      <div class="platform-badge">Your Investment Portfolio Intelligence Platform</div>

      <!-- Desktop Navigation -->
      <nav class="header-nav desktop-nav">
        <button class="nav-btn signin-btn" @click="setAuth(true, 'signin')">
          Sign In
        </button>
        <button class="nav-btn getstarted-btn" @click="setAuth(true, 'signup')">
          Get Started
        </button>
      </nav>

      <!-- Mobile Menu Toggle -->
      <button class="mobile-menu-btn" @click="toggleMenu">
        <i :class="`pi ${isMenuOpen ? 'pi-times' : 'pi-bars'}`"></i>
      </button>
    </div>

    <!-- Mobile Navigation -->
    <nav v-if="isMenuOpen" class="mobile-nav">
      <button class="nav-btn signin-btn mobile" @click="setAuth(true, 'signin'); toggleMenu()">
        Sign In
      </button>
      <button class="nav-btn getstarted-btn mobile" @click="setAuth(true, 'signup'); toggleMenu()">
        Get Started
      </button>
    </nav>
  </header>
</template>

<style scoped>
.landing-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.sebi-registration-bar {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  padding: 8px 16px;
  text-align: center;
}

.sebi-text {
  color: #f1f5f9;
  font-size: 1.08rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-logo {
  display: flex;
  align-items: center;
}

.logo-img {
  height: 56px;
  width: auto;
}

.platform-badge {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: #e4ebed;
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  background: linear-gradient(135deg, #0e38d2 0%, #4fb6ed 100%);
  padding: 4px 16px;
  border-radius: 4px;
  white-space: nowrap;
}

.header-nav {
  display: flex;
  align-items: center;
  gap: 16px;
}

.desktop-nav {
  display: flex;
}

.mobile-nav {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background: white;
}

.nav-btn {
  padding: 10px 20px;
  font-size: 0.9375rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  white-space: nowrap;
}

.nav-btn.mobile {
  width: 100%;
}

.signin-btn {
  background: white;
  color: #3b82f6;
  border: 2px solid #3b82f6;
}

.signin-btn:hover {
  background: #eff6ff;
}

.getstarted-btn {
  background: #3b82f6;
  color: white;
}

.getstarted-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #1f2937;
  cursor: pointer;
  padding: 8px;
}

@media (max-width: 768px) {
  .sebi-registration-bar {
    padding: 6px 12px;
  }

  .sebi-text {
    font-size: 0.936rem;
  }

  .desktop-nav {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .header-container {
    padding: 12px 20px;
  }

  .logo-img {
    height: 48px;
  }

  .platform-badge {
    position: static;
    transform: none;
    font-size: 0.625rem;
    padding: 3px 10px;
    margin: 8px auto 0;
    display: block;
    text-align: center;
  }

  .header-container {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .header-logo {
    order: 1;
  }

  .mobile-menu-btn {
    order: 2;
  }

  .platform-badge {
    order: 3;
    width: 100%;
  }
}

@media (max-width: 640px) {
  .sebi-text {
    font-size: 0.864rem;
  }
}

@media (max-width: 480px) {
  .sebi-registration-bar {
    padding: 6px 8px;
  }

  .sebi-text {
    font-size: 0.72rem;
    letter-spacing: 0.01em;
  }
}

@media (max-width: 380px) {
  .sebi-text {
    white-space: normal;
    font-size: 0.792rem;
    line-height: 1.3;
  }
}
</style>
